var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDenmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 13.9131H31.8645C30.8419 6.06262 24.1292 0 16 0C14.8053 0 13.6417 0.132063 12.5217 0.380313V13.9131H12.5218Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34787 13.9131V1.9455C3.95456 4.34262 0.809436 8.73956 0.135498 13.9131H8.34787V13.9131Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34781 18.0868H0.135498C0.809436 23.2604 3.95456 27.6573 8.34787 30.0544L8.34781 18.0868Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 18.0869V31.6196C13.6417 31.8678 14.8053 31.9999 16 31.9999C24.1292 31.9999 30.8419 25.9373 31.8645 18.0868H12.5217V18.0869Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmark);
export default __webpack_public_path__ + "static/media/denmark.b8641ebb.svg";
export { ForwardRef as ReactComponent };